<ng-container *ngIf="cardType === 'simple'; else article">
  <div class="eq-card-module eq-flex eq-flex-col eq-h-full eq-min-h-[279px] eq-justify-between eq-p-6 lg:eq-min-h-[316px] lg:eq-max-w-[464px]">
    <div class="eq-flex eq-flex-col eq-text-blue-darkBlue ">
      <ng-container *ngIf="rendering?.fields?.H2TitleTag?.value">
        <h2 *ngIf="data?.Title" class="eq-mb-4 eq-text-heading5-m eq-font-bold lg:eq-text-heading5">{{data?.Title}}</h2>
      </ng-container>
      <ng-container *ngIf="!rendering?.fields?.H2TitleTag?.value">
        <h3 *ngIf="data?.Title" class="eq-mb-4 eq-text-heading5-m eq-font-bold lg:eq-text-heading5">{{data?.Title}}</h3>
      </ng-container>
      <p *ngIf="data?.Description" class="eq-text-body-sm-m eq-line-clamp-3 lg:eq-text-body-sm">{{data?.Description}}</p>
    </div>
    
    <div class="eq-mt-auto eq-flex eq-overflow-hidden">
      <a *ngIf="data?.FileHref && !data?.File1Href && !data?.File2Href" 
        hybridHref 
        href="{{data?.FileHref}}" 
        target="_blank"
        attr.aria-label="{{data?.FileText}}"
        class="eq-flex eq-items-center eq-uppercase eq-text-blue-actionblue-80 eq-text-body-xs eq-gap-x-4 eq-w-fit"
      >
        {{data?.FileExtension}}
        <div class="eq-flex eq-items-center">
          <i class="eq-icon-download eq-text-i-24 eq-text-blue-darkBlue"></i>
        </div>
      </a>
      <div *ngIf="data?.File1Href && (data?.File2Href || data?.File1Href)" class="eq-flex eq-flex-col eq-gap-4">
        <a 
          hybridHref 
          href="{{data?.FileHref}}" 
          target="_blank"
          attr.aria-label="{{data?.FileText}}"
          class="eq-flex eq-items-center eq-uppercase eq-text-blue-actionblue-80 eq-text-body-xs eq-gap-x-4 eq-w-fit"
          >
          {{data?.FileText}}
          <div class="eq-flex eq-items-center">
            <span class="eq-text-black-natural-60 eq-text-tabs-m lg:eq-text-tabs eq-uppercase">{{data?.FileExtension}}</span>
          </div>
        </a>
        <a *ngIf="data?.File1Href"
          hybridHref 
          href="{{data?.File1Href}}" 
          target="_blank"
          attr.aria-label="{{data?.File1Text}}"
          class="eq-flex eq-items-center eq-uppercase eq-text-blue-actionblue-80 eq-text-body-xs eq-gap-x-4 eq-w-fit"
          >
          {{data?.File1Text}}
          <div class="eq-flex eq-items-center">
            <span class="eq-text-black-natural-60 eq-text-tabs-m lg:eq-text-tabs eq-uppercase">{{data?.File1Extension}}</span>
          </div>
        </a>
        <a *ngIf="data?.File2Href" 
          hybridHref 
          href="{{data?.File2Href}}" 
          target="_blank"
          attr.aria-label="{{data?.File2Text}}"
          class="eq-flex eq-items-center eq-uppercase eq-text-blue-actionblue-80 eq-text-body-xs eq-gap-x-4 eq-w-fit"
          >
          {{data?.File2Text}}
          <div class="eq-flex eq-items-center">
            <span class="eq-text-black-natural-60 eq-text-tabs-m lg:eq-text-tabs eq-uppercase">{{data?.File2Extension}}</span>
          </div>
        </a>
      </div>
      <a *ngIf="data?.Link?.href" hybridHref href="{{data?.Link?.href}}" [attr.label]="data?.Link?.text" [target]="data?.Link?.target" [attr.rel]="data?.Link?.target == '_blank' ? 'noopener' : null" class="eq-flex eq-items-center eq-text-blue-actionblue-80 eq-underline eq-decoration-blue-actionBlue-80 eq-text-text-link-m eq-gap-x-4 eq-w-fit lg:eq-text-text-link">
        {{data?.Link?.text}}
        <div class="eq-flex eq-items-center">
          <i class="eq-icon-arrow_right eq-text-i-24 eq-text-blue-darkBlue"></i>
        </div>
      </a>
    </div>
  </div>
</ng-container>

<ng-template #article>
  <ng-container *ngIf="cardType === 'article'; else video">
    <div class="eq-card-module eq-flex eq-flex-col eq-h-full eq-min-h-[279px] lg:eq-min-h-[316px] lg:eq-max-w-[464px]">
      <img [src]="data.Image?.src" [alt]="data.Image?.alt" class="eq-object-cover eq-object-center eq-w-full eq-h-full eq-max-h-[263px]"/>
      <div class="eq-flex eq-flex-col eq-p-6 eq-pt-5 eq-h-full eq-justify-between">
        <div class="eq-flex eq-flex-col eq-text-blue-darkBlue ">
          <h2 *ngIf="data?.Title" class="eq-mb-4 eq-text-heading5-m eq-font-bold lg:eq-text-heading5">{{data?.Title}}</h2>
          <p *ngIf="data?.Description" class="eq-mb-4 eq-text-body-m eq-text-black-natural-80 lg:eq-text-body">{{data?.Description}}</p>
        </div>
        <a *ngIf="data?.Link?.href" hybridHref href="{{data?.Link?.href}}" [attr.label]="data?.Link?.text" [target]="data?.Link?.target" [attr.rel]="data?.Link?.target == '_blank' ? 'noopener' : null" class="eq-mt-auto eq-flex eq-items-center eq-text-blue-actionBlue eq-underline eq-decoration-blue-actionBlue eq-text-text-link-m eq-gap-x-4 eq-w-fit lg:eq-text-text-link">
          {{data?.Link?.text}}
        </a>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #video>
  <!-- Content to display if none of the conditions are true -->
  <p>Video Card module</p>
</ng-template>